import * as React from 'react';
import { PropsRoute } from '@makemydeal/dr-activities-common';

import type { IRootProps } from '../types';
import { getAllRoutes } from '../utils/routes';

import Activity from './Activity';
import { StyledOpenDealRoot } from './Activity.style';

const Root: React.FC<IRootProps> = (props: IRootProps) => {
    const path = props.baseRoute;
    const routes = getAllRoutes(path);

    return (
        <StyledOpenDealRoot className="dr-activities-open-deal-v2" data-testid="dr-activities-open-deal-v2-container">
            <PropsRoute {...props} path={routes.ROOT} component={Activity} />
        </StyledOpenDealRoot>
    );
};

export default Root;
